import { Component, ElementRef, EventEmitter, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Subject, Subscription } from 'rxjs';
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { debounceTime } from 'rxjs/operators';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';
import { JdDataService } from 'src/app/jd-data.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { GlobalService } from 'src/app/_services/global.service';
import { ContinentHandlerService } from 'src/app/_services/continent-handler.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStage } from 'src/app/enums/CallStage';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ContinentType } from '../../common-interfaces-classes/ContinentType';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { MatChipsModule } from '@angular/material/chips';
declare const clevertap;

export interface SuggestedTitle {
  name: string;
  key: string;
  type: 'title' | 'skill' | 'company';
  selected?: boolean;
  count?: number;
};

@Component({
    selector: 'app-jd-filter',
    templateUrl: './jd-filter.component.html',
    styleUrls: ['./jd-filter.component.scss'],
    standalone: false
})
export class JdFilterComponent implements OnInit {

  showCreateProjectSpinner: Boolean = false;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedRegion: ContinentType = 'asia';
  onChangesContinentClearLocation: boolean = false;
  defaultContinent: ContinentType = 'asia';
  haseuaisourcingaccess: boolean = false;

  subscriptions: Subscription[] = [];
  parshedJD: any;

  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';

  @Input() projectname: any;
  @Input() jobdescription: any;
  @Input() changedJD: any = false;
  @Input() dublicateProjectNameError: boolean;
  @Input() projectnameSpecialCharError: boolean;

  @ViewChild('skillsInputEl') skillsInputEl!: ElementRef<HTMLInputElement>;
  @ViewChild('jobtitlesInputEl') jobtitlesInputEl!: ElementRef<HTMLInputElement>;
  locationError: boolean = false;
  locationChange: boolean = false;



  /** Jobtitle filter */
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  jobTitleList: any = [];
  jobTitleSelectedList: any = [];
  showJobTitleLoader: boolean = false
  jobTitleStatus = CallStage.CURRENT.toString();


  /** Skills filter */
  skillsInput: UntypedFormControl = new UntypedFormControl(null);
  skillsList: any = [];
  skillsSelectedList: any = [];
  showSkillLoader: boolean = false

  /** Target Company filter */
  companyInput: UntypedFormControl = new UntypedFormControl(null);
  companyList: any = [];
  companySelectedList: any = [];
  showCompanyLoader: boolean = false

  /** Target Industry filter */
  industryInput: UntypedFormControl = new UntypedFormControl(null);
  industryList: any = [];
  industrySelectedList: any = [];
  showIndustryLoader: boolean = false;


  /** Select seniority */
  seniority: String = null;
  seniorityList = GlobalService.seniorityLevels;
  seniorityInput: UntypedFormControl = new UntypedFormControl(null);

  /** Years Of Experience */
  yearsofexperienceFrom: UntypedFormControl = new UntypedFormControl(null);
  yearsofexperienceTo: UntypedFormControl = new UntypedFormControl(null);

  fromyearsofexperience: number = null;
  toyearsofexperience: number = null;

  /** Function filter */
  functionsInput: UntypedFormControl = new UntypedFormControl(null);
  functionsList: any = [];
  functionsSelectedList: any = [];
  showFunctionsLoader: boolean = false;

  /** Location filter */
  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationList: any = [];
  locationSelectedList: any = [];
  showLocationLoader: boolean = false;

  @ViewChild('cannotModifyModel') cannotModifyModel: TemplateRef<any>;
  @ViewChild('candidateNotFoundModel') candidateNotFoundModel: TemplateRef<any>;

  continentList: string[] = ["asia", "africa", "north america", "oceania", "south america", 'europe'];

  /** Used to apply debounce on typeahead */
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  isOpenAITitleLoading: boolean = true;
  showOpenAITitleSuggestions: number;

  aiSuggestedTitles: SuggestedTitle[] = [];
  aiSuggestedSkills: SuggestedTitle[] = [];
  aiSuggestedCompany: SuggestedTitle[] = [];

  updatedAiTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();
  updatedAiSkillChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();
  updatedAiCompanyChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  clearAiTitleChips: EventEmitter<void> = new EventEmitter<void>();
  clearAiSkillChips: EventEmitter<void> = new EventEmitter<void>();
  clearAiCompanyChips: EventEmitter<void> = new EventEmitter<void>();
  jobTitleExtendedChipList: any[] = [];
  addOnBlur: any;
  industryTopList: any;
  showSubmitJdSpinner: boolean = false;
  jdLocation: string = '';
    /**Type of distance */
  locationDistanceUnit: string = 'kilometers';
  /**Value of range of distance in location filter */
  locationDistanceRange: string = '100';
  totalEligibleCandidates: number = 0;
  @ViewChild('locationSearch') locationSearch!: ElementRef;


  get openAIAll() {
    const jobTitle = this.jobTitleSelectedList?.length ?  this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.chipkey}"`): [];
     const skills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => `"${skill.chipkey}"`):[];
    // const pastJobTitle = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`): [];
    // const keyword = this.keyWordInputValue && this.keyWordInputValue.trim() ? `"${this.keyWordInputValue}"` : null;

    return jobTitle.concat(skills).join(' OR ');
  }

  get jobtitleAndSkillAIData(): {boolean?: string | null, jobtitles?: string[], skills?: string[]} {
    if(this.jobTitleSelectedList?.length > 0 && this.skillsSelectedList?.length > 0) {
    return {
      boolean: null,
      jobtitles:  this.jobTitleSelectedList?.length ?  this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => jobTitle.chipkey):[],
      skills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => skill.chipkey) : []
    }
  }
  }

  industryForCompanyAiSuggestions: string[] | [] = [];
  companyAiSuggestions: any[] = [];
  loadSuggestions: boolean = false;

  get showCompanyAiSuggestions() {
    return this.companySelectedList.filter(c => !c.isSuggested).length;
  }

  get jobTitleAggregateType(): string {
    return this.jobTitleStatus == 'Current' ? 'current_jobtitle' : this.jobTitleStatus == 'Past' ? 'pastjobtitle' : 'jobtitle';
  }

  get openAIExcludeJobTitles(): string[] {
    return this.jobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  get openAIExcludeSkills(): string[] {
    return this.skillsSelectedList.map(skill => skill.chipkey);
  }

  get hasCityLocationSelected(): boolean {
    return this.locationSelectedList?.some((location: any) =>
      (location?.location_type || '').toLowerCase() === 'city'
    ) || false;
  }

  isOpenAISkillsLoading: boolean = true;
  showOpenAISkillsSuggestions: number;
  location_type: UntypedFormControl = new UntypedFormControl(null) ;
  wholeNumberForDistance: boolean = true;
  showModifyProjectSpinner: boolean = false;
  showLimitedResultsInfo: boolean = false;
  @ViewChild('insuffiicientCandidatesModel') insuffiicientCandidatesModel: TemplateRef<any>;

  cloneprojectnumber: string = '';
  companySubscription: Subscription = null;
  skillSubscription: Subscription = null;
  redirectSource: string | null = null;
  locations_meta_data: any[] = [];


  constructor(
    private personSearchService: PersonSearchService,
    private jdDataService: JdDataService,
    private aiSourcingService: AiSourcingService,
    private continentHandlerService: ContinentHandlerService,
    private router: Router,
    private modelService: NgbModal,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private aggService: AggregationService,
    private companyInsightsService: CompanyInsightsService,
    private localstorageservice: LocalStorageService,
    private talentInsightsService: TalentInsightsService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.redirectSource = params['source'] || '';
      if (this.redirectSource == 'edit') {
        this.cloneprojectnumber = window.location.pathname?.split('/')[3];
      }
    });

    this.defaultContinent = this.localstorageservice.getItem('region');
    this.haseuaisourcingaccess = Number(this.localstorageservice.getItem('haseuaisourcingaccess')) ? true : false;

    /** Get parshed job description */
    const jdsubscription = this.jdDataService.jdDataEventObs.subscribe((response: any) => {
      if (response && response.status == 'success') {
        this.parshedJD = response;
        this.populateJDData(response);
        this.redirectSource = response?.editProjectDetails?.redirectSource ? response?.editProjectDetails?.redirectSource : null;
        this.cloneprojectnumber = response?.editProjectDetails?.cloneprojectnumber ? response?.editProjectDetails?.cloneprojectnumber : '';
      } else {
        this.parshedJD = response;
        this.redirectSource = response?.editProjectDetails?.redirectSource ? response?.editProjectDetails?.redirectSource : null;
        this.cloneprojectnumber = response?.editProjectDetails?.cloneprojectnumber ? response?.editProjectDetails?.cloneprojectnumber : '';
      }
    });
    this.subscriptions.push(jdsubscription);

    if (!this.parshedJD) {
      const storeProjectData = JSON.parse(this.localstorageservice.getItem('parshedJD'));

      if (storeProjectData && storeProjectData.filterApplied) {
        if(storeProjectData?.cloneprojectnumber) {
          this.cloneprojectnumber = storeProjectData?.cloneprojectnumber;
          this.redirectSource = storeProjectData?.redirectSource ? storeProjectData?.redirectSource : null;
        };
        this.locations_meta_data = storeProjectData?.filterApplied?.locations_meta_data ? storeProjectData?.filterApplied?.locations_meta_data : [];
        this.updateAllAppliedFilter(storeProjectData.filterApplied);
      } else if (storeProjectData && storeProjectData.parshedJD && !storeProjectData.filterApplied) {
        this.parshedJD = storeProjectData?.parshedJD;
        this.redirectSource = storeProjectData?.redirectSource ? storeProjectData?.redirectSource : null;
        this.populateJDData(this.parshedJD);
      }
    };

    /** Get selected continent from the continent selector */
    const continentUpdateObs = this.continentHandlerService.continentUpdateObservable.subscribe((continent: ContinentType) => {
      this.selectedRegion = continent;
      if (!this.onChangesContinentClearLocation) {
        this.locationInput.setValue(null);
        this.jdLocation = '';
      } else {
        this.onChangesContinentClearLocation = false;
      }
    });
    this.subscriptions.push(continentUpdateObs);

    /** Clear filter data event selector */
    const clearFilterDataSub = this.aiSourcingHandlerService.getEnterManualEvent.subscribe((res: boolean) => {
      this.locationInput.setValue(null);
      this.yearsofexperienceFrom.setValue(null);
      this.yearsofexperienceTo.setValue(null);
      this.seniorityInput.setValue(null);
      this.fromyearsofexperience = null
      this.toyearsofexperience = null
      this.jobTitleSelectedList = [],
      this.functionsSelectedList = [],
      this.locationSelectedList = [],
      this.skillsSelectedList = [],
      this.industrySelectedList = [],
      this.companySelectedList = [],
      this.companySelectedList = [],
      this.selectedRegion = 'asia'
    });
    this.subscriptions.push(clearFilterDataSub);

    // Initialize the typeahead search subject
    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.typeAheadSearch(event, type);
    });

    // this.locationInput.valueChanges.subscribe((value) => {
    //   this.locationChange = true;
    //   if (!value) {
    //     this.locationError = true;
    //     this.locationSelectedList = [];
    //   } else {
    //     // this.locationError = true;
    //     // this.locationSelectedList = [];
    //   }
    // });

  };

  focusOut() {
    if (!this.locationSelectedList.length) {
      this.locationInput.setValue(null);
      this.locationError = true;
    }

    if (this.locationChange) {
      this.locationInput.setValue(null);
      this.locationError = true;
    }
  };

  /**
   * Handle location input blur without clearing selections
   */
  onLocationInputBlur() {
    // Only clear the input field, not the selected locations
    if (this.locationInput.value) {
      this.locationInput.setValue(null);
    }
    // Validate that at least one location is selected
    if (!this.locationSelectedList.length) {
      this.locationError = true;
    } else {
      this.locationError = false;
    }
  };

  /**
   * Method to get ai suggession
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.aiSuggestion && changes.aiSuggestion.currentValue && !changes.aiSuggestion.firstChange) {
      const s: SuggestedTitle[] = changes.aiSuggestion.currentValue;

      /**
       * Process the suggestion and return already applied chips with existing data/state
       * @param s
       * @param userSelectedList
       */
      const processSuggestion = (s: SuggestedTitle[], userSelectedList: any[]) => {
        return s.map(s => {
          const isAlreadyApplied = userSelectedList.find(j => j.chipkey == s.name && j.isSuggested)
          if (isAlreadyApplied) {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: isAlreadyApplied.isExcluded, isMandatory: isAlreadyApplied.isMandatory, chipkey: isAlreadyApplied.chipkey, chipvalue: isAlreadyApplied.chipvalue, key: isAlreadyApplied.key })
          } else {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: false, isMandatory: false, chipkey: s.name, chipvalue: s.name, key: s.name })
          }
        }).filter(Boolean);
      }
      // process title
      const titleSuggestion = s.filter(s => s.type == 'title');
      const userSelectedTitle = this.jobTitleSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedTitles = processSuggestion(titleSuggestion, userSelectedTitle);
      const combiledTitles = [].concat(aiSuggestedTitles, userSelectedTitle);
      this.jobTitleSelectedList = _.uniq(combiledTitles, 'chipkey');

      // process skill
      const skillSuggestion = s.filter(s => s.type == 'skill');
      const userSelectedSkill = this.skillsSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedSkills = processSuggestion(skillSuggestion, userSelectedSkill);
      const combiledSkills = [].concat(aiSuggestedSkills, userSelectedSkill);
      this.skillsSelectedList = _.uniq(combiledSkills, 'chipkey');
    }
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  openaiTitleLoading({ state, count, suggested }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;

    // suggested && (this.aiSuggestedTitles = suggested);
    // this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5;
  }

    openaiSkillsLoading({ state, count, suggested }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;

    // suggested && (this.aiSuggestedSkills = suggested);
    // this.aiQuery && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('skills', true);
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
       const suggestionsWithKey = suggestions.map(suggestion => {
      return {
       key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    let removedSuggestions = [];
    if(newSuggestions.length) {
      this.jobTitleSelectedList = this.jobTitleSelectedList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.chipkey === suggestion.chipkey));
      removedSuggestions.length && (this.jobTitleSelectedList = this.jobTitleSelectedList.filter(chiplist => chiplist.chipkey != removedSuggestions[0].chipkey));
    }

  }

  /**
   * Method to fetch similar company AI suggession
   */
  getCompanyAiSuggestions() {
    this.companyAiSuggestions = [];
    this.loadSuggestions = false;
    const payload = {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      companynames: this.companySelectedList.filter(c => !c.isSuggesteds).map(company => company.key?.replace('.aisearch', '')),
    }
    this.companyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.industryForCompanyAiSuggestions = res?.data?.results ? res?.data?.results.filter(company => this.companySelectedList.find(c => c.chipkey.toLowerCase() == company.name)).map(company => company.industry) : [];
        const localRequestObject = this.aggService.getRequestWithFilters();

        localRequestObject['industries'] = _.uniq(this.industryForCompanyAiSuggestions);
        delete localRequestObject.searchedfrom;
        const aggregatetype = 'company';

        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentcompany",
          input: "",
        });

        this.personSearchService.getTotalAggs(localRequestObject).subscribe((response) => {
          if (response && response.status === 'success') {
            const reportsAggs = response.data.aggregations;
            this.companyAiSuggestions = reportsAggs?.current_company || [];
            this.loadSuggestions = true;
            this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.find(company => company.chipkey.toLowerCase() == c.key)).slice(0, 5).map(c => ({
              ...c, key: `${c.key}.aisearch`,
              chipkey: c.key,
              isExcluded: false,
              isMandatory: false,
              isSuggestion: true,
              isSuggested: true
            }))
          }
        });
      }
    });
  };


  removeAllAiSuggestion() {
    this.clearAiTitleChips.emit();
    this.clearAiSkillChips.emit();
    this.clearAiCompanyChips.emit();
  }

  /**
   * This function is used to emit the typeahead search event
   * It will be called whenever the user types something in the input field
   * @param event - The input event from the user
   * @param type - The type of input field (e.g., jobtitle, skills, etc.)
   */
  onTypeAheadSearch(event: Event, type: string) {
    this.typeAheadSubject.next({ event, type });
  }


  /**
   * This function is used to handle the typeahead search for various fields
   * It will call the appropriate service based on the type of input field
   * @param event - The input event from the user
   * @param type - The type of input field (e.g., jobtitle, skills, etc.)
   */
  typeAheadSearch(event: any, type: string) {
    const searchValue = (event.target as HTMLInputElement).value;
    if (!(type == 'fromyearsofexperience' || type == 'toyearsofexperience' || type == 'skills' || type == 'company') && searchValue && searchValue.length < 3) return;

    switch (type) {
      case 'jobtitle': {
        this.showJobTitleLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle', this.selectedRegion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobTitleList = response.data;
            this.showJobTitleLoader = false
          } else {
            this.jobTitleList = [];
            this.showJobTitleLoader = false;
          }
        });
        break;
      }

      case 'skills': {
        if(searchValue.length>0){
          this.showSkillLoader = true
        }else{
          this.showSkillLoader = false;
        }
        this.skillSubscription && this.skillSubscription.unsubscribe();
        this.skillSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'skill', this.selectedRegion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsList = response.data;
            this.showSkillLoader = false
          } else {
            this.skillsList = [];
            this.showSkillLoader = false
          }
        });
        break;
      }

      case 'company': {
        if(searchValue.length>0){
          this.showCompanyLoader = true
        }else{
          this.showCompanyLoader = false;
        }
        this.companySubscription && this.companySubscription.unsubscribe();
        this.companySubscription = this.personSearchService.getPersonSearchListing(searchValue, 'company', this.selectedRegion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const companyList = response.data;
            const payload = companyList.map(item => {
              if (item.value) {
                return { name: item.value };
              }
            }).filter(Boolean);
            payload?.length &&
              this.personSearchService.getCompanyLogoV2(payload).subscribe((response: any) => {
                this.companyList = response.data;
                this.showCompanyLoader = false;
              });
          } else {
            this.companyList = [];
            this.showCompanyLoader = false;
          }
        });
        break;
      }

      case 'industry': {
        this.showIndustryLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'industry', this.selectedRegion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.industryList = response.data;
            this.showIndustryLoader = false
          } else {
            this.industryList = [];
            this.showIndustryLoader = false
          }
        });
        break;
      }

      case 'location': {
        this.showLocationLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'location').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationList = response.data.slice(0, 3);
            this.showLocationLoader = false
          } else {
            this.locationList = [];
            this.showLocationLoader = false
          }
        });
        break;
      }

      case 'functions': {
        this.showFunctionsLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'function', this.selectedRegion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.functionsList = response.data;
            this.showFunctionsLoader = false
          } else {
            this.functionsList = [];
            this.showFunctionsLoader = false
          }
        });
        break;
      }

      case 'fromyearsofexperience': {
        const fromYears = this.yearsofexperienceFrom.value
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          this.fromyearsofexperience = fromYears;
          if (!isNaN(this.toyearsofexperience) && this.fromyearsofexperience > this.toyearsofexperience) {
            this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
            break;
          }
          this.yearsofexperienceFrom.setErrors(null);
        } else {
          if (event.target.value == '') {
            this.yearsofexperienceFrom.setErrors(null);
            this.fromyearsofexperience = null
          } else {
            this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
          }
        }
        break;
      }

      case 'toyearsofexperience': {
        const toYears = this.yearsofexperienceTo.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
          this.toyearsofexperience = toYears;
          if (!isNaN(this.fromyearsofexperience) && this.toyearsofexperience <= this.fromyearsofexperience) {
            this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
            break;
          }
          this.yearsofexperienceTo.setErrors(null);
        } else {
          if (event.target.value == '') {
            this.yearsofexperienceTo.setErrors(null);
            this.toyearsofexperience = null
          } else {
            this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
          }
        }
        break;
      }
    }
  }

  /**
   * Remove typeahead suggestions based on the input length
   * @param type
   */
  removeTypeahead(type: String) {
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
    }
  }

   /**
   * This function is used to handle the selection of items from the autocomplete dropdown
   * It will add the selected item to the respective list and reset the input field
   * @param event - The selection event from the autocomplete dropdown
   * @param type - The type of input field (e.g., jobtitle, skills, etc.)
   * @param contactEvent - Optional parameter for contact-related events
   */
  selectedItem(event: any, type: string, contactEvent: any = null) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll(".mat-input-element");
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });

    switch (type) {
      case "jobtitle": {
        this.jobTitleList = []
        if (contactEvent !== 'enter' && event.option && event.option.value) {
          this.jobTitleSelectedList.push({
            ...event.option.value,
            isExcluded: false,
            isMandatory: false,
            chipkey: event.option.value.key
          });
        } else {
          this.jobTitleSelectedList.push({
            key: event,
            isExcluded: false,
            isMandatory: false,
            chipkey: event
          });
          // this.jobTitleExtendedChipList.push({ name:inputValue, value: inputValue, isSuggested: false, canStar: true, type: 'Job Title' });
          this.autocomplete.closePanel();
        }

        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter((res: any) => (res?.key?.trim()))
        this.jobTitleInput.reset();
        setTimeout(() => this.jobtitlesInputEl.nativeElement.focus(), 0);
        break;
      }

      case 'skills': {
        this.skillsList = []
        if (contactEvent !== 'enter' && event.option && event.option.value) {
          this.skillsSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.skillsSelectedList.push({ key: event, chipkey: event })
          this.autocomplete.closePanel();
        }
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'key');
        this.skillsSelectedList = this.skillsSelectedList.filter((res: any) => (res?.key?.trim()))
        this.skillsInput.reset();
        setTimeout(() => this.skillsInputEl.nativeElement.focus(), 0);
        break;
      }

      case 'company': {
        this.companyList = []
        if (event.option && event.option.value) {
          this.companySelectedList.push({ ...event.option.value, chipkey: event.option.value.key, isExcluded: false, isMandatory: false})
        } else {
          this.companySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value, isExcluded: false, isMandatory: false})
          this.autocomplete.closePanel();
        }
        this.companySelectedList = _.uniq(this.companySelectedList, 'key');
        this.getCompanyLogoForCompanyChips(_.pluck(this.companySelectedList, 'key'))
        const companyList = this.companySelectedList.filter(c => !c.isSuggested);
        // this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));

        if (companyList && companyList.length) {
          this.getCompanyAiSuggestions();
        }

        this.companyInput.reset();
        break;
      }

      case 'industry': {
        this.industryList = []
        if (event.option && event.option.value) {
          this.industrySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.industrySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'key');
        this.industryInput.reset();
        break;
      }

      case 'location': {
        this.locationList = []
        if (event.option && event.option.value) {
          this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key, location_type: event.option.value.location_type, continent: event.option.value.continent });
          this.location_type.setValue(event.option.value.location_type);
        } else {
          this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value, location_type: '', continent: '' });
          this.autocomplete.closePanel();
        }
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
        this.locationInput.reset();
        // this.locationError = false;
        // this.locationChange = false;

        break;
      }

      case 'functions': {
        this.functionsList = []
        if (event.option && event.option.value) {
          this.functionsSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.functionsSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.functionsSelectedList = _.uniq(this.functionsSelectedList, 'key');
        this.functionsInput.reset();
        break;
      }

    }

    if (type != 'jobtitle' && type != 'skills' && !this.openAIAll && type != 'fullname' && type != 'gender') {
      this.removeAllAiSuggestion();
    }
  };


  isLocationDisabled(location: any): boolean {
    return !this.haseuaisourcingaccess && location.location_continent.toLowerCase() === 'europe';

  }

  getTooltipText(location: any): string {
    if (this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations. \n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

  capitalizeFirst(value: string): string {
    if (!value) return '';
    return value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  /**
   * Method to apply filter with AI suggession
   * @param item
   * @param type
   */
  addToSelectedList(item: any, type: string) {
    switch (type) {
      case 'company': {
        this.companySelectedList.push({ ...item, isExcluded: false, isMandatory: false });
        this.companySelectedList = _.uniq(this.companySelectedList, 'key');
        this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));

        if (!item.isSuggested) {
          const companyList = this.companySelectedList.filter(c => !c.isSuggested);
          if (companyList && companyList.length) {
            this.getCompanyAiSuggestions();
          }
        }
        this.companyInput.reset();
        break;
      }
    }
  };

  /**
   * Method to exclude and include filter
   * @param item
   * @param type
   */
  excludeFilterItem(item: any, type: string) {
    if (type === "company") {
      this.companySelectedList = this.companySelectedList.map(company => company.key == item ? { ...company, isExcluded: !company.isExcluded } : company);
    };
  };

  /**
   * Method to use get company logo for company chips
   * @param companyList
   * @returns
   */
  getCompanyLogoForCompanyChips(companyList: Array<string>) {
    if (!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return name[0];
    }).filter(Boolean);

    const payload = [];
    updatedCompanyList.forEach(item => {
      payload.push({
        name: item
      })
    })

    this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
      this.companySelectedList?.length && this.companySelectedList.map(company => {
        if (res && res.data?.length) {
          res.data.map((logosData: any) => {
            if ((logosData.key === company.chipkey) || (logosData.key === company.key)) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  };

  /**
   * Methos to remove selected chips from the list
   * @param value
   * @param type
   */
  removeChip(value: any, type: string) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        let removedSuggestions = [];
        if(value.isSuggested == true  ) {
          removedSuggestions.push({ name: value.chipkey, selected: false, type: 'title', key: value.suggestedTitle.key });
        }
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter((item: any) => item.key !== value.key);
        this.updatedAiTitleChips.emit(removedSuggestions)
        break;

      case 'skills':
        let removedSuggestionsSkills = [];
        if(value.isSuggested == true  ) {
          removedSuggestionsSkills.push({ name: value.chipkey, selected: false, type: 'skill', key: value.suggestedTitle.key });
        }
        this.skillsSelectedList = this.skillsSelectedList.filter((item: any) => item.key !== value.key);
        this.updatedAiSkillChips.emit(removedSuggestionsSkills)
        break;

      case 'company':
        this.companySelectedList = this.companySelectedList.filter((item: any) => item.key !== value.key);
        break;

      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter((item: any) => item.key !== value.key);
        break;

      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter((item: any) => item.key !== value.key);
        break;

      case 'functions':
        this.functionsSelectedList = this.functionsSelectedList.filter((item: any) => item.key !== value.key);
        break;
    }
  };


  /**
   * This function is used to check if there is any error in the filter input
   * It will return false as there is no error handling implemented yet
   * @returns {boolean} - Returns false indicating no error
   */
  filterInputError(): Boolean {
    if(this.locationSelectedList.length) {
      this.locationError = false;
    } else {
      this.locationError = true;
    }
    if (this.projectname && !this.dublicateProjectNameError && !this.projectnameSpecialCharError && this.jobTitleSelectedList?.length &&
      this.locationSelectedList?.length && this.skillsSelectedList?.length && !this.locationError && this.wholeNumberForDistance &&
      Number(this.locationDistanceRange) > 0 && Number(this.locationDistanceRange) <= 500) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * Populate the JD data into the respective lists
   * @param jdData
   */
  populateJDData(data: any) {
    const parshedJd = data ? data.data : null;
    if (parshedJd) {

      if (parshedJd['suggestedjobtitle'] || parshedJd['jobtitles']) {
        const jobtitles = parshedJd['suggestedjobtitle'].concat(parshedJd['jobtitles']);
        if(jobtitles && jobtitles.length) {
        const request = this.aggService.getRequestWithFilters();
        request.aggregatetype = 'current_jobtitle';
        request.jobtitles = jobtitles;
        request.continentstobeincluded = this.selectedRegion ? [this.selectedRegion] : [];
        this.personSearchService.getTotalAggs(request).subscribe((res:any)=>{
        this.jobTitleSelectedList = res?.data?.aggregations?.current_jobtitle?.map((title: any) => ({
          key: title?.key,
          isExcluded: false,
          isMandatory: false,
          chipkey: title?.key
        }));
        })
      } else {
        this.jobTitleSelectedList = [];
      }


       // this.jobTitleExtendedChipList.push({ name: j.key.replace(/\.searchastext/g, ''), value: j.key, starred: j.isMandatory, type: 'Job Title', canStar: true, isSuggested: j.isSuggested, key: j.suggestedKey });

      }

      if (parshedJd['mandatoryskills'] || parshedJd['preferredskills'] || parshedJd['tools']) {
        let skills = parshedJd['mandatoryskills'].concat(parshedJd['preferredskills']).concat(parshedJd['tools']);
        skills = _.uniq(skills, (skill: string) => skill);
        this.skillsSelectedList = skills.map((skill: any) => ({
          key: skill,
          chipkey: skill
        }));
        //  const request = this.aggService.getRequestWithFilters();
        // request.aggregatetype = 'skills';
        // request.preferredskills = skills;
        // this.personSearchService.getTotalAggs(request).subscribe((res:any)=>{
        // this.skillsSelectedList = res?.data?.aggregations?.skills?.map((skill: any) => ({
        //   key: skill.key,
        //   chipkey: skill.key
        // }));
    }

      if (parshedJd['companies'] && parshedJd['companies']?.length > 0) {
        const request = this.aggService.getRequestWithFilters();
         request.aggregatetype = 'current_company';
        request.companies = parshedJd['companies'];
            request.continentstobeincluded = this.selectedRegion ? [this.selectedRegion] : [];

        this.personSearchService.getTotalAggs(request).subscribe((res:any)=>{
        this.companySelectedList = res?.data?.aggregations?.current_company.map((company: any) => ({
          chipkey: company.key,
          key: company.key,
          isExcluded: false,
          isMandatory: false,
        }));
      })
    }

      if (parshedJd['industries'] && parshedJd['industries']?.length > 0) {
        const request = this.aggService.getRequestWithFilters();
        request.aggregatetype = 'current_industry';
        request.industries = parshedJd['industries'];
            request.continentstobeincluded = this.selectedRegion ? [this.selectedRegion] : [];

        this.personSearchService.getTotalAggs(request).subscribe((res:any)=>{
          this.industrySelectedList = res?.data?.aggregations?.current_industry.map((industry: any) => ({
            chipkey: industry.key,
            key: industry.key,
            isExcluded: false,
            isMandatory: false,
         }));
      })
      }

      if (parshedJd['normalizedlocations'] && parshedJd['normalizedlocations']?.length > 0) {
        const request = this.aggService.getRequestWithFilters();
        request.aggregatetype = 'location';
        request.locations = parshedJd['normalizedlocations'];
        request.continentstobeincluded = this.selectedRegion ? [this.selectedRegion] : [];

        this.locationSelectedList = parshedJd['normalizedlocations'].map((location: any) => ({
          chipkey: location.exactlocationmatch,
          key: location.exactlocationmatch,
          location_type: location.location_type,
          continent: location.continent
        }));

        this.locationSelectedList = this.locationSelectedList?.filter((loc: any) => this.haseuaisourcingaccess || loc.continent?.toLowerCase() !== 'europe');

        // this.personSearchService.getTotalAggs(request).subscribe((res: any) => {
        //   this.locationSelectedList = res?.data?.aggregations?.current_location.map((location: any) => ({
        //     chipkey: location.key,
        //     key: location.key,
        //     isExcluded: false,
        //     isMandatory: false,
        //   }));
        // })
      }


    //   if (parshedJd['locations'] && parshedJd['locations'].length) {
    //     if(parshedJd['exactlocationmatch']) {
    //       this.locationSelectedList = [{ chipkey: parshedJd['exactlocationmatch'], key: parshedJd['exactlocationmatch'] }]
    //         this.locationInput.setValue(parshedJd['exactlocationmatch']);
    //         this.location_type.setValue(parshedJd['location_type'] ? parshedJd['location_type'] : '');
    //         this.locationChange = false;
    //     } else {
    //       this.locationSelectedList = [];
    //       this.locationInput.setValue(null);
    //       this.location_type.setValue(null);
    //   }
    // } else {
    //     this.locationSelectedList = [];
    //     this.locationInput.setValue(null);
    //     this.location_type.setValue(null);
    // }

      if (parshedJd['yearsofexperience']) {
        const minExp = parshedJd['yearsofexperience'].min;
        this.fromyearsofexperience = minExp ? minExp : null;
        this.yearsofexperienceFrom.setValue(minExp);

        const maxExp = parshedJd['yearsofexperience'].max;
        this.toyearsofexperience = maxExp ? maxExp : null;
        this.yearsofexperienceTo.setValue(maxExp)
      }

      if(parshedJd['continents']) {
        this.onChangesContinentClearLocation = true;
        this.selectedRegion = parshedJd['continents'][0] ? parshedJd['continents'][0].toLowerCase() : 'asia';

        if (!this.haseuaisourcingaccess && this.selectedRegion == 'europe') {
          this.errorMessage = "Requested EU data unavailable";
          setTimeout(() => { this.errorMessage = '' }, 2000);
          this.continentHandlerService.emitContinentUpdate(this.defaultContinent);
          this.locationSelectedList = [];
          this.locationInput.setValue(null);
        } else if (!this.continentList.includes(this.selectedRegion)) {
          this.continentHandlerService.emitContinentUpdate(this.defaultContinent);
          this.locationSelectedList = [];
          this.locationInput.setValue(null);
        } else {
          this.continentHandlerService.emitContinentUpdate(this.selectedRegion);
        }

      }
    }

 // const updateTitleSuggestions = this.jobTitleSelectedList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.name, selected: true, type: 'title', key: js.key }));




  }

  /**
   * Method to handle the renaming of a project.
   */

  openCannotModifyModel() {
    this.showModifyProjectSpinner = true;
        if (!this.projectname) return;

    const projectDetails = {
      projectname: this.projectname,
      jobdescription: this.jobdescription,
      parsedjobdescription: this.parshedJD ? this.parshedJD : null,
      minexperience: this.fromyearsofexperience,
      maxexperience: this.toyearsofexperience,
      workplacetype: null,
      jobtitles: this.jobTitleSelectedList?.filter((jobtitle: any) => jobtitle.isExcluded == false).map((j: any) => j.key) || [],
      functions: this.functionsSelectedList && this.functionsSelectedList.length ? this.functionsSelectedList.map((j: any) => j.key) : null,
      location: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList[0].key : null,
      skills: this.skillsSelectedList?.map((j: any) => j.key) || [],
      industries: this.industrySelectedList?.map((j: any) => j.key) || [],
      companies: this.companySelectedList?.filter((company: any) => company.isExcluded == false).map((j: any) => j.key) || [],
      excluded_companies: this.companySelectedList?.filter((company: any) => company.isExcluded == true).map((j: any) => j.key) || [],
      continent: _.uniq(this.locationSelectedList.map((loc: any) => loc.continent))[0],
      distancefromselectedlocationsmeasurementunit: this.hasCityLocationSelected ?  this.locationDistanceUnit : null,
      distancefromselectedlocations: this.hasCityLocationSelected ? Number(this.locationDistanceRange) : null,
      eligible_count_required: true,
      location_type: this.location_type?.value ? this.location_type?.value : null,
      isCloned: this.cloneprojectnumber ? true : false,
      locations: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList.map((j: any) => j.key) :  [],
      continentstobeincluded:_.uniq(this.locationSelectedList.map((loc: any) => loc.continent)),
  };
  const locations = this.locationSelectedList.map(loc => loc.key?.replace('.searchastext', ''));
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('insightsjobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);
          }
        })

        const serviceCall = this.redirectSource == 'edit' ? this.aiSourcingService.modifyProject(projectDetails, this.cloneprojectnumber) : this.aiSourcingService.createProject(projectDetails);
        serviceCall.subscribe((response: any) => {
        this.showModifyProjectSpinner = false;
        if (response && response.body?.status == 'success') {
            this.totalEligibleCandidates = response.body.totalresultscount;
            if(this.totalEligibleCandidates > 500) {
              this.modelService.open(this.cannotModifyModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            } else {
              this.modelService.open(this.insuffiicientCandidatesModel, { windowClass: "autopilotsufficient", centered: true, backdrop: 'static', keyboard: false });
            }
        }
      }, (err) => {
          this.showModifyProjectSpinner = false;
          if (err && err.error && err.error.status == 'failure' && err.error.totalresultscount == 0) {
            this.modelService.open(this.candidateNotFoundModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          } else {
            this.errorMessage = "Something went wrong. Please try again.";
            setTimeout(() => { this.errorMessage = '' }, 2000);
          }
        });


   // this.modelService.open(this.cannotModifyModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
  }


  /**
   * Method to create a new project with the selected filters and job description
   */
  createProject() {
    if (!this.projectname) return;

    const projectDetails = {
      projectname: this.projectname,
      jobdescription: this.jobdescription,
      parsedjobdescription: this.parshedJD ? this.parshedJD : null,
      minexperience: this.fromyearsofexperience,
      maxexperience: this.toyearsofexperience,
      workplacetype: null,
      jobtitles: this.jobTitleSelectedList?.filter((jobtitle: any) => jobtitle.isExcluded == false).map((j: any) => j.key) || [],
      functions: this.functionsSelectedList && this.functionsSelectedList.length ? this.functionsSelectedList.map((j: any) => j.key) : [],
      location: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList[0].key : null,
      skills: this.skillsSelectedList?.map((j: any) => j.key) || [],
      industries: this.industrySelectedList?.map((j: any) => j.key) || [],
      companies: this.companySelectedList?.filter((company: any) => company.isExcluded == false).map((j: any) => j.key) || [],
      excluded_companies: this.companySelectedList?.filter((company: any) => company.isExcluded == true).map((j: any) => j.key) || [],
      continent: _.uniq(this.locationSelectedList.map((loc: any) => loc.continent))[0],
      distancefromselectedlocationsmeasurementunit: this.hasCityLocationSelected ?  this.locationDistanceUnit : null,
      distancefromselectedlocations: this.hasCityLocationSelected ? Number(this.locationDistanceRange) : null,
      location_type: this.location_type?.value ? this.location_type?.value : null,
      isCloned: this.cloneprojectnumber ? true : false,
      locations: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList.map((j: any) => j.key) :  [],
      continentstobeincluded:_.uniq(this.locationSelectedList.map((loc: any) => loc.continent)),
    };

    this.showCreateProjectSpinner = true;
    if(this.redirectSource == 'edit') {
      this.aiSourcingHandlerService.setDisplayPageEvent('evaluation-page');
      const storeProjectData = {
        projectName: this.projectname,
        projectDescription: this.jobdescription,
        parshedJD: this.parshedJD,
        filterApplied: {...this.syncProjectDetailsToSetLocalstorage(), locations_meta_data: this.locationSelectedList},
        isEvaluationPage: true,
        cloneprojectnumber: this.cloneprojectnumber,
        redirectSource: this.redirectSource
      };
      this.localstorageservice.setItem('parshedJD', JSON.stringify(storeProjectData));
      this.dismiss();
      this.router.navigate([`/ai-sourcing/evaluation-criteria`]);
    } else {
    this.aiSourcingService.createProject(projectDetails).subscribe((response: any) => {
      this.showCreateProjectSpinner = false;
      if (response && response.body?.status == 'success') {
        if (response.body?.duplicate) {
          this.infoMessage = "Duplicate project name. Please try with a different name.";
          setTimeout(() => { this.infoMessage = '' }, 2000);
        } else {
          this.successMessage = "Project created successfully.";
          this.aiSourcingHandlerService.setDisplayPageEvent('evaluation-page');
          const storeProjectData = {
            projectName: this.projectname,
            projectDescription: this.jobdescription,
            parshedJD: response.body,
            filterApplied: {...this.syncProjectDetailsToSetLocalstorage(), locations_meta_data: this.locationSelectedList},
            isEvaluationPage: true,
            cloneprojectnumber: this.cloneprojectnumber
          };

          this.localstorageservice.setItem('parshedJD', JSON.stringify(storeProjectData));
          this.dismiss();

              /**
     * Create Project
     */
         const createProjectParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Project Name": this.projectname
        }
        clevertap.event.push("Autopilot-Submit AI Search Criteria",createProjectParams);
          // this.router.navigate([`/ai-sourcing/evaluation-criteria/${response.projectnumber}`]);
          this.router.navigate([`/ai-sourcing/evaluation-criteria`]);
          setTimeout(() => { this.successMessage = '' }, 2000);
        }
      } else {
        this.errorMessage = "Something went wrong. Please try again.";
        setTimeout(() => { this.errorMessage = '' }, 2000);
      }
    }, (err) => {
      this.showCreateProjectSpinner = false;
      if (err && err.error && err.error.status == 'failure' && err.error.totalresultscount == 0) {
        this.modelService.open(this.candidateNotFoundModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      } else {
        this.errorMessage = "Something went wrong. Please try again.";
        setTimeout(() => { this.errorMessage = '' }, 2000);
      }
    });
  }
  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'skill', key: suggestion.name }
      };
    });
    const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    let removedSuggestions = [];
    if (newSuggestions.length) {
      this.skillsSelectedList = this.skillsSelectedList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.chipkey === suggestion.chipkey));
      removedSuggestions.length && (this.skillsSelectedList = this.skillsSelectedList.filter(chiplist => chiplist.chipkey != removedSuggestions[0].chipkey));
    }
  }

/**
 * Method to sync all the applied filter
 * @returns
 */
  syncProjectDetailsToSetLocalstorage() {
    const projectDetails = {
      projectname: this.projectname,
      jobdescription: this.jobdescription,
      parsedjobdescription: this.parshedJD ? this.parshedJD : null,
      minexperience: this.fromyearsofexperience,
      maxexperience: this.toyearsofexperience,
      workplacetype: null,
      jobtitles: this.jobTitleSelectedList?.filter((jobtitle: any) => jobtitle.isExcluded == false).map((j: any) => j.key) || [],
      functions: this.functionsSelectedList && this.functionsSelectedList.length ? this.functionsSelectedList.map((j: any) => j.key) : null,
      location: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList[0].key : null,
      skills: this.skillsSelectedList?.map((j: any) => j.key) || [],
      industries: this.industrySelectedList?.filter((industry: any) => industry.isExcluded == false).map((j: any) => j.key) || [],
      companies: this.companySelectedList?.filter((company: any) => company.isExcluded == false).map((j: any) => j.key) || [],
      excluded_companies: this.companySelectedList?.filter((company: any) => company.isExcluded == true).map((j: any) => j.key) || [],
      continent: _.uniq(this.locationSelectedList.map((loc: any) => loc.continent))[0],
      distancefromselectedlocationsmeasurementunit: this.hasCityLocationSelected ?  this.locationDistanceUnit : null,
      distancefromselectedlocations: this.hasCityLocationSelected ? Number(this.locationDistanceRange) : null,
      location_type: this.location_type.value,
      isCloned: this.cloneprojectnumber ? true : false,
      // locations: this.locationSelectedList || [],
      locations: this.locationSelectedList && this.locationSelectedList.length ? this.locationSelectedList.map((loc: any) => typeof loc === 'object' && loc.key ? loc.key : loc) : [],
      continentstobeincluded:_.uniq(this.locationSelectedList.map((loc: any) => loc.continent)),
    };

    return projectDetails;
  }

  /**
   * Method to update applied filters
   * @param data
   * @returns
   */
  updateAllAppliedFilter(data: any) {
    if (!data) return;

    if (data.seniority) {
      this.seniorityInput.setValue(data.seniority);
    }
    if (data.minexperience) {
      this.yearsofexperienceFrom.setValue(data.minexperience);
      this.fromyearsofexperience = data.minexperience;
    }
    if (data.maxexperience) {
      this.yearsofexperienceTo.setValue(data.maxexperience);
      this.toyearsofexperience = data.maxexperience;
    }
    if (data.jobtitles) {
      // this.jobTitleSelectedList = data.jobtitles.map((res: string) => ({ key: res, chipkey: res, isExcluded: false, isMandatory: false }));
      this.jobTitleSelectedList = data.jobtitles.map((res: string) => (this.chipCleanUp(res)));

    }
    if (data.function) {
      this.functionsSelectedList = [{ key: data.function, chipkey: data.function, isExcluded: false, isMandatory: false }];
      // this.functionsSelectedList = data.function.map((res: string) => ({ key: res, chipkey: res, isExcluded: false, isMandatory: false }));
    }
    if (data.location) {
      this.locationSelectedList = [{ key: data.location, chipkey: data.location, isExcluded: false, isMandatory: false }];
      // this.locationInput.setValue(data.location);
      this.locationDistanceUnit = data?.distancefromselectedlocationsmeasurementunit ? data?.distancefromselectedlocationsmeasurementunit : (data?.distanceunit == "miles" || data?.distanceunit == 'mi' ? 'miles' : 'kilometers');
      this.locationDistanceRange = data?.distancefromselectedlocations ? data?.distancefromselectedlocations : (data?.distance ? data?.distance : '100');
      this.location_type.setValue(data?.location_type)
    }
    // if (data?.locations && !this.cloneprojectnumber.trim()) {
    //   this.locationSelectedList = data.locations.map((res: any) => ({ key: res.key, chipkey: res.chipkey, location_type: res.location_type, continent: res.continent }));
    // } else {
    //   this.locationSelectedList = [];
    // };
    if (data?.locations_meta_data) {
      this.locationSelectedList = data.locations_meta_data.map((res: any) => ({ key: res?.key || res?.value, chipkey: res?.chipkey || res?.value, location_type: res?.location_type || res?.type, continent: res?.continent || res?.location_continent }));
    } else {
      this.locationSelectedList = [];
    };
    if (data.skills) {
      // this.skillsSelectedList = data.skills.map((res: string) => ({ key: res, chipkey: res, isExcluded: false, isMandatory: false }));
      this.skillsSelectedList = data.skills.map((res: string) => (this.chipCleanUp(res)));
    }
    if (data.industries) {
      this.industrySelectedList = data.industries.map((res: string) => ({ key: res, chipkey: res, isExcluded: false, isMandatory: false }));
    }
    if (data.companies) {
      // this.companySelectedList = data.companies.map((res: string) => ({ key: res, chipkey: res, isExcluded: false, isMandatory: false }));
      this.companySelectedList = data.companies.map((res: string) => (this.chipCleanUp(res)));
    }
    if (data.excluded_companies) {
      const excludeCompanySelectedList = data.excluded_companies.map((res: string) => ({ key: res, chipkey: res, isExcluded: true, isMandatory: false }));;
      this.companySelectedList.concat(excludeCompanySelectedList);
    }
    if (data.continent) {
      this.selectedRegion = data.continent;
    }

    if(data.parsedjobdescription) {
      this.parshedJD = data.parsedjobdescription;
    }
  }

/**
 *
 * @param string
 * @returns
 */
  chipCleanUp(string: string) {
    if (string.includes('.aisearch')) {
      return { key: string, chipkey: string.split(".")[0], isExcluded: false, isMandatory: false, isSuggestion: true }
    } else {
      return { key: string, chipkey: string, isExcluded: false, isMandatory: false, isSuggestion: false };
    }
  };

  getLocationTypeahead() {
    this.showLocationLoader = true;
    this.jdLocation = '';
    const request = this.aggService.getRequestWithFilters();
    request.continentstobeincluded = this.selectedRegion ? [this.selectedRegion] : [];
    request.location_type_required  = 1;
    request.aggregatetype = 'location';
      this.personSearchService.getTotalAggs(request).subscribe((response: any) => {
          if (response.status == 'success' ) {
            this.locationList = response.data.aggregations.location.slice(0, 3);
            this.locationList = this.locationList.map((loc: any) => ({
              ...loc,
              value: loc.key
            }));
            this.showLocationLoader = false
          } else {
            this.locationList = [];
            this.showLocationLoader = false
          }
        });
        setTimeout(() => {
    this.locationSearch?.nativeElement.focus();
  }, 0);
  }

   wholeNumberValidation(event) {
    if (/^\-?\d+$/.test(event.target.value)) {
      this.wholeNumberForDistance = true;
    }
    else { this.wholeNumberForDistance = false; }
  }

  getMissedMandatoryFiels() {
    const missedFields = [];
    if (!this.projectname) {
      missedFields.push('Project Name');
    }
    if (!this.jobTitleSelectedList.length) {
      missedFields.push('Job Title');
    } if (!this.locationSelectedList.length) {
      missedFields.push('Location');
    } if (!this.skillsSelectedList.length) {
      missedFields.push('Skills');
    } return missedFields;
  }

  handleTabOpen(event: KeyboardEvent) {
  event.preventDefault(); // stop default TAB behavior
  this.getLocationTypeahead();
}

}
